import { AdgroupFormData } from '@tt4b/ttam-enums';
import { convertContentToStr } from './../../../utils/index';

export function getFieldFromGroupData(fields: (keyof AdgroupFormData)[], adgroupData: AdgroupFormData) {
  const value = {};
  fields.forEach(key => {
    value[key] = adgroupData[key];
  });
  return value;
}

export function isSameContent(value, other) {
  return convertContentToStr(value) === convertContentToStr(other);
}

export function allSameFiled(objArr: Partial<AdgroupFormData>[], field: keyof AdgroupFormData, firstFieldBatchItem) {
  return objArr.every(item => isSameContent(item[field], firstFieldBatchItem));
}

export function uniqueBatchField(objArr, field: keyof AdgroupFormData) {
  const fieldArr = objArr.map(item => convertContentToStr(item[field]));
  const fieldSet = new Set(fieldArr);
  return fieldArr.length === fieldSet.size;
}
